<template lang="pug">
#app
  template(v-if="!isApplicationPage")
    .enter(:class="{ active: s > 100 }")
    transition(name="side_animate")
      side_menu(v-if="sideMenuOpen === true" @close="close_side_menu")
    .space
      router-link.logo(to="/")
      Menu
    header.top(:class="{ active: s > 100 }")
      router-link.logo(to="/")
      Menu
    header.topS(:class="{ active: s > 100 }")
      transition(name="fade")
        .side_menu_open_button(v-if="sideMenuOpen === false" @click="sideMenuOpen = true")
      router-link.logo(to="/")
    transition(name="fade")
      SmallMenu(v-if="sideMenuOpen === false" @click.native="sideMenuOpen = true")
    .middle(:class="{ home: $route.path == '/' || $route.path == '/newUser', pofile: $route.path === '/me' }")
      transition(name="fade" mode="out-in")
        router-view(:user-data="userData" :key="$route.fullPath")
    .bottom_for_space
      Footer
    footer.bottom
      Footer(:updateTime="updateTime" :visitor_count="visitor_count")

  template(v-else)
    router-view.wrapper
</template>

<script>
import { fetchPortalBlockData } from '@/api/client/Project'
import headerpic from '@/components/pic/headerpic'
import Menu from '@/components/Menu'
import SmallMenu from '@/components/SmallMenu'
import Footer from '@/components/Footer'
import side_menu from '@/components/side_menu'
export default {
  props: {
    dialogVisible: Boolean
  },
  components: { Menu, SmallMenu, Footer, headerpic, side_menu },
  data() {
    return {
      updateTime: '2025/05/20',
      visitor_count: '172400',
      sideMenuOpen: false,
      userData: null,
      open: false,
      s: null,
      profile: {},
      authorized: false,
      form: {
        email: '',
        password: ''
      },
      user: require('./assets/user.jpg'),
      loginNow: 'no',


    }
  },
  watch: {
    '$route'(to, from) {
      this.open = false
      window.scroll(0, 0)
    },
  },
  async created() {
    const { data } = await fetchPortalBlockData()
    if (!data) return
    this.updateTime = data.update_time ? data.update_time.replaceAll('-','/') : ''
    this.visitor_count = data.visitor_count ? data.visitor_count.replaceAll('-','/') : ''
  },
  mounted() {
    window.addEventListener('scroll', this.scroll)
  },
  computed: {
    isApplicationPage () {
      return this.$route.name === 'applicationForm'
    }
  },
  methods: {
    close_side_menu() {
      this.sideMenuOpen = false
    },
    scroll() {
      this.s = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.error--text
  color: #ff5252 !important
  caret-color: #ff5252 !important
*
  position: relative

.el-popup-parent--hidden
  padding: 0 !important
.el-input__inner
  border: 0
  border: solid 0.5px #D2D2D2 !important

body,html
  width: 100%
  min-height: 100vh
  box-sizing: border-box
  margin: 0
  padding: 0

#app
  width: 100%
  min-height: 100vh
  box-sizing: border-box
  margin: 0
  padding: 0
  position: relative
  overflow-x: hidden

  +ie
    // overflow-x: visible
  .el-dialog
    +phone
      width: 90% !important
  .enter
    position: fixed
    // +bb
    +size(18%,28vw)
    right: -7%
    top: -8vw
    z-index: 10
    background: url('./assets/enter.png')
    +bgcon
    opacity: 0.8
    background-size: 100% auto
    background-position: 0, 0
    +flexrow
    +pad
      display: none

    &.active
      display: none

    .button_right_side_reg
      position: relative
      width: 2.5vw
      min-width: 29.42px
      height: max-content
      font-size: 13px
      margin-top: 8.3vw
      margin-left: 0.3vw
      letter-spacing: 1.5px
      color: #878787
      border-radius: 5px
      +flexcolumn
      +flexCenter
      cursor: pointer
      // +bb
      +smallcom
        font-size: 0.5vw
        min-width: initial
      +ie
        margin-top: -10.5vw
        +maxcom
          margin-top: -10.6vw
        +com
          margin-top: -10vw
        +smallcom
          font-size: 13px
          margin-top: -10vw


    .button_right_side_login
      position: relative
      width: 2.5vw
      min-width: 29.42px
      height: max-content
      font-size: 13px
      border-radius: 5px
      letter-spacing: 1.5px
      margin-top: 8.3vw
      margin-left: 1vw
      color: #878787
      cursor: pointer
      +smallcom
        margin-left: 0.5vw
        font-size: 0.5vw
        min-width: initial
        +ie
          font-size: 13px

  .space
    width: 100%
    height: 11.5vw
    box-sizing: border-box
    visibility: hidden
    +pad
      height: 80px
    +phone
      // height: 20vw
      // margin-left: -1%
      // min-height: 75px
  .top
    width: 100%
    height: 11.5vw
    // +bb
    background: url('./assets/head.png')
    position: fixed
    box-sizing: border-box
    top: 0
    +bgcover
    background-size: 100% auto
    background-position-y: 0
    z-index: 9
    // +bb
    +pad
      background: url('./assets/headM.png')
      height: 80px
      border-bottom: solid 2px #777
    +phone
      z-index: 20
      width: 101%
    &.active
      display: none


    .logo
      position: absolute
      +size(7%, 40%)
      background: url('./assets/logo.png')
      +bgcon
      top: 20%
      left: 3%
      +pad
        +size(16%, 65%)
        left: 50%
        margin-left: -8%
      +phone
        +size(18%, 70%)
        margin-left: -9%
    .pad_user_re
      position: absolute
      letter-spacing: 1.5px
      display: none
      color: #777
      cursor: pointer
      +pad
        display: block
        font-weight: bold
        border-bottom: solid 0.5px #999
        padding: 3px
        right: 20px
        top: 12px

    .pad_user_log
      position: absolute
      display: none
      letter-spacing: 1.5px
      color: #777
      cursor: pointer
      +pad
        display: block
        top: 40px
        right: 20px
        font-weight: bold
        padding: 3px
  .topS
    position: fixed
    top: 0
    z-index: 20
    width: 100%
    height: 80px
    box-sizing: border-box
    background-color: #F7F7F7
    box-shadow: 0px 0px 15px 0.5px #999
    display: none
    +pad
      height: 80px
    +phone
    &.active
      display: block
    .side_menu_open_button
      background: url('./assets/side_menu_open.png')
      width: 30px
      height: 30px
      +bgcon
      margin-left: 3vw
      margin-top: 25px
      cursor: pointer
      +pad
        display: none
    .logo
      position: absolute
      +size(89px, 56px)
      background: url('./assets/logo.png')
      +bgcon
      top: 15%
      left: 50%
      margin-left: -44.5px

    .enbutton_scroll_re
      position: absolute
      right: 20px
      top: 12px
      font-size: 16px
      letter-spacing: 1.5px
      padding: 3px
      color: #555
      border-bottom: solid 1px #777
      cursor: pointer
    .enbutton_scroll_login
      position: absolute
      right: 20px
      top: 40px
      font-size: 16px
      padding: 3px
      letter-spacing: 1.5px
      color: #555
      cursor: pointer

  .el-button-pos
    margin-left: 80%
    z-index: 0
    background-color: #238FEF
    color: #fff

  .space-LF
    margin-left: 50%
    margin-right: 50%


  .middle
    width: 100%
    box-sizing: border-box

    &.pofile
      background-color: #E5E5E5


  .bottom_for_space
    bottom: 0
    width: 100%
    visibility: hidden
    +phone
      min-width: 375px
      min-height: 360px
    +ie
      margin-top: 20vw
  .bottom
    position: absolute
    bottom: 0
    width: 100%
    +phone
      min-width: 375px
      min-height: 360px
    +ie
      margin-top: 20vw
    &.home
      position: relative
.pageHeader
  width: 100%
  border-bottom: solid 1px #EEE
  +flexrow
  align-items: center
  flex-wrap: wrap
  +phone
    border: 0
  .pageName
    font-size: 30px
    color: #555
    +phone
      font-size: 25px
  .pageTabBlock
    box-sizing: border-box
    padding: 0px 0 0 20px
    +phone
      display: none
    .pageTab
      font-size: 18px
      margin-right: 10px
      color: #999
      &.active
        color: #000
  .pageSelectBlock
    display: none
    position: relative
    margin-left: 10px
    outline: none
    +phone
      display: block
    .pageSelect
      font-size: 14px
      padding: 0 0 2px 0
      box-sizing: border-box
      color: #777
      border-bottom: solid 1px #999
      text-align: center
      width: 150px
      // margin-left: 10px
      cursor: pointer
      .tri
        width: 10px
        height: 10px
        float: right
        border-top: solid 1px #777
        border-right: solid 1px #777
        transform: rotate(135deg)
        margin-right: 2px
        margin-top: 2px;
        transition: 0.3s
    .pageTabOptionBlock
      position: absolute
      width: 150px
      +flexcolumn
      border: solid 1px #777
      margin-top: 1px
      opacity: 0
      visibility: hidden
      transition: 0.3s
      z-index: 10
      .pageTabOption
        text-align: center
        font-size: 14px
        color: #777
        background-color: rgba(#fff, 0.8)
        border-bottom: solid 1px #777
        &:last-child
          border: 0
        &:active
          background-color: rgba(#999, 0.8)
          color: white
.pageBlock
  width: 100%
  +flexrow
  +flexCenter
  .prev
    width: 17px
    height: 17px
    background-image: url('./assets/tri.png')
    +bgcon
    transform: rotate(90deg)
    cursor: pointer
    margin-right: 8px
  .cur_page
    margin-right: 5px
  .line
  .total
    margin-left: 5px
    cursor: pointer
  .next
    width: 17px
    height: 17px
    background-image: url('./assets/tri.png')
    +bgcon
    transform: rotate(270deg)
    cursor: pointer
    margin-left: 8px
</style>



// WEBPACK FOOTER //
// src/App.vue